module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('tplheader'), _vm._v(" "), _c('tplLeftPanel'), _vm._v(" "), _c('div', {
    staticClass: "fixed-top-menu-outer",
    attrs: {
      "id": "fixed-top-menu-outer"
    }
  }, [_c('div', {
    staticClass: "fixed-top-menu"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.savePreCheck,
      "iconclass": "fa fa-save",
      "label": "Ment"
    },
    model: {
      value: (_vm.is_save),
      callback: function($$v) {
        _vm.is_save = $$v
      },
      expression: "is_save"
    }
  }), _vm._v(" "), (_vm.form.user.id != 0) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: '/card/edit',
        query: {
          id: 0,
          owner_id: _vm.form.user.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("Új kártya")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "main-panel",
    attrs: {
      "id": "main-panel"
    }
  }, [_c('div', {
    staticClass: "content-panel"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-panel-top-btn-group"
  }, [_c('ajaxLoaderButton', {
    attrs: {
      "onClick": _vm.savePreCheck,
      "iconclass": "fa fa-save",
      "label": "Ment"
    },
    model: {
      value: (_vm.is_save),
      callback: function($$v) {
        _vm.is_save = $$v
      },
      expression: "is_save"
    }
  }), _vm._v(" "), (_vm.form.user.id != 0) ? _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": {
        path: '/card/edit',
        query: {
          id: 0,
          owner_id: _vm.form.user.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("Új kártya")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    attrs: {
      "enctype": "multipart/form-data"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(3), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showFillPopup
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v("Kitöltés segéd")]), _vm._v(" "), _c('select2ajax', {
    attrs: {
      "url": "shibuser/search",
      "change": _vm.shibUserChange,
      "id": "dn",
      "label": "Címtár felhasználó",
      "errors": _vm.errors,
      "name": "dn"
    },
    model: {
      value: (_vm.form.shib_users),
      callback: function($$v) {
        _vm.$set(_vm.form, "shib_users", $$v)
      },
      expression: "form.shib_users"
    }
  }), _vm._v(" "), (_vm.showADSelectbox()) ? _c('select2ajax', {
    attrs: {
      "url": "aduser/search",
      "change": _vm.ADUserChange,
      "id": "ad_user",
      "label": "AD felhasználó",
      "errors": _vm.errors,
      "name": "ad_user"
    },
    model: {
      value: (_vm.form.ad_users),
      callback: function($$v) {
        _vm.$set(_vm.form, "ad_users", $$v)
      },
      expression: "form.ad_users"
    }
  }) : _vm._e(), _vm._v(" "), _c('inputbox', {
    attrs: {
      "inputCheck": "name",
      "id": "name",
      "label": "Név",
      "errors": _vm.errors,
      "name": "username"
    },
    model: {
      value: (_vm.form.user.name),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "name", $$v)
      },
      expression: "form.user.name"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "id": "email",
      "label": "Email",
      "errors": _vm.errors,
      "name": "email"
    },
    model: {
      value: (_vm.form.user.email),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "email", $$v)
      },
      expression: "form.user.email"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "inputCheck": "phone",
      "id": "phone",
      "label": "Telefon",
      "errors": _vm.errors,
      "name": "phone"
    },
    model: {
      value: (_vm.form.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "phone", $$v)
      },
      expression: "form.user.phone"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "inputCheck": "neptuncode",
      "maxlength": "6",
      "id": "neptun_code",
      "label": "Neptun kód",
      "errors": _vm.errors,
      "name": "neptun_code"
    },
    model: {
      value: (_vm.form.user.neptun_code),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "neptun_code", $$v)
      },
      expression: "form.user.neptun_code"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "inputCheck": "orgware",
      "id": "orgware_id",
      "label": "Orgware ID",
      "errors": _vm.errors,
      "name": "orgware_id"
    },
    model: {
      value: (_vm.form.user.orgware_id),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "orgware_id", $$v)
      },
      expression: "form.user.orgware_id"
    }
  }), _vm._v(" "), _c('combobox', {
    attrs: {
      "id": "id_doc_type_id",
      "label": "Azonosító okmány típusa",
      "errors": _vm.errors,
      "name": "id_doc_type_id"
    },
    model: {
      value: (_vm.form.id_doc_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "id_doc_type", $$v)
      },
      expression: "form.id_doc_type"
    }
  }), _vm._v(" "), _c('inputbox', {
    attrs: {
      "inputCheck": "personalDocumentID",
      "id": "id_doc_id",
      "label": "Azonosító okmány száma",
      "errors": _vm.errors,
      "name": "id_doc_id"
    },
    model: {
      value: (_vm.form.user.id_doc_id),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "id_doc_id", $$v)
      },
      expression: "form.user.id_doc_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-3"
  }, [_c('inputbox', {
    attrs: {
      "disabled": "1",
      "id": "account_expires",
      "label": "AD lejárati idő",
      "name": "account_expires"
    },
    model: {
      value: (_vm.form.user.account_expires),
      callback: function($$v) {
        _vm.$set(_vm.form.user, "account_expires", $$v)
      },
      expression: "form.user.account_expires"
    }
  })], 1), _vm._v(" "), (this.form.user.account_expires_btn) ? _c('div', {
    staticClass: "col-xs-9"
  }, [_c('button', {
    staticClass: "btn btn-white",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.modifyAccountExpires
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("Idő hosszabbítás 1 évvel")])]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-8 col-md-8 col-lg-8"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "border": "1px solid #E5E9EC",
      "margin-bottom": "15px"
    },
    style: ({
      width: _vm.video_div_w + 'px',
      height: _vm.video_div_h + 'px'
    })
  }, [_c('i', {
    staticClass: "fa fa-camera",
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "top": "50%",
      "font-size": "40px",
      "color": "#d8dbde",
      "margin": "-30px 0px 0px -30px"
    }
  }), _vm._v(" "), _c('canvas', {
    staticStyle: {
      "position": "absolute",
      "left": "-10000px"
    },
    attrs: {
      "width": _vm.video_canvas_w,
      "height": _vm.video_canvas_h
    }
  }), _vm._v(" "), _c('video', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "width": "100%",
      "height": "100%",
      "autoplay": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    }
  }, [(_vm.cameraOn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.takePictureEnabled,
      "type": "button"
    },
    on: {
      "click": _vm.takePicture
    }
  }, [_c('i', {
    staticClass: "fa fa-picture-o"
  }), _vm._v("Kép készítése")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.turnOnOffCamera
    }
  }, [_c('i', {
    staticClass: "fa fa-camera"
  }), _vm._v(_vm._s(_vm.cameraTurnOnOffBtnTitle))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "upload_photo_btn",
      "type": "button"
    },
    on: {
      "click": _vm.uploadPhotoClick
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v("Fotó feltöltése")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "position": "absolute",
      "left": "-10000px"
    },
    attrs: {
      "accept": "image/*",
      "id": "upload_file",
      "type": "file"
    },
    on: {
      "change": _vm.uploadPhoto
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-4 col-md-4 col-lg-4"
  }, [_c('div', {
    staticStyle: {
      "position": "relative",
      "width": "250px",
      "min-height": "300px",
      "border": "1px solid #E5E9EC",
      "margin-bottom": "15px"
    }
  }, [_c('i', {
    staticClass: "fa fa-image",
    staticStyle: {
      "position": "absolute",
      "left": "50%",
      "top": "50%",
      "font-size": "40px",
      "color": "#d8dbde",
      "margin": "-30px 0px 0px -30px"
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.previewImage
    }
  })])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.cardsShow) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', _vm._l((_vm.form.user.cards), function(card) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(card.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(card.card_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(card.created))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(card.rf_id))]), _vm._v(" "), _c('td', [_c('table', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cardRulesShow(card)),
        expression: "cardRulesShow(card)"
      }],
      staticClass: "table table-bordered"
    }, [_vm._m(6, true), _vm._v(" "), _c('tbody', _vm._l((card.rules), function(rule) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(rule.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rule.valid_from) + " - " + _vm._s(rule.valid_to))]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "center"
        }
      }, [(rule.public) ? _c('i', {
        staticClass: "fa fa-check"
      }) : _vm._e(), (!rule.public) ? _c('i', {
        staticClass: "fa fa-times"
      }) : _vm._e()]), _vm._v(" "), _c('td', {
        staticStyle: {
          "text-align": "center"
        }
      }, [(rule.primaryc) ? _c('i', {
        staticClass: "fa fa-check"
      }) : _vm._e(), (!rule.primaryc) ? _c('i', {
        staticClass: "fa fa-times"
      }) : _vm._e()])])
    }), 0)])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(card.status))]), _vm._v(" "), _c('td', [(_vm.cardEditButtonShow(card.rules)) ? _c('ul', {
      staticClass: "icon-list"
    }, [_c('li', {
      staticClass: "dropdown"
    }, [_vm._m(7, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu"
    }, [_c('li', {
      staticClass: "dropdown-header"
    }, [_vm._v("Opciók")]), _vm._v(" "), _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/card/edit/',
          query: {
            id: card.id
          }
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    }), _vm._v("Módosít")])], 1)])])]) : _vm._e()])])
  }), 0)])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n                Nem található kártya.\n              ")])])])])])])]), _vm._v(" "), (_vm.crop_popup) ? _c('div', {
    staticClass: "modal-content no-overlay",
    style: ({
      width: _vm.cropPopupWidth + 'px'
    }),
    attrs: {
      "id": "cropmodal"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideCropPopupClick
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Vágás")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "crop-image",
      "src": _vm.form.user.new_photo
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-large",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideCropPopupClick
    }
  }, [_vm._v("Bezár")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-large",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.crop
    }
  }, [_vm._v("Mentés")])])]) : _vm._e(), _vm._v(" "), (_vm.form.user.id == 0 && this.fill_popup) ? _c('fillPopup', {
    attrs: {
      "fillUserData": _vm.fillUserData,
      "hidepopup": _vm.hideFillPopup
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.user.id != 0 && this.fill_popup) ? _c('fillPopupModify', {
    attrs: {
      "user": _vm.form.user,
      "hidepopup": _vm.hideFillPopup
    },
    on: {
      "onBtnClick": _vm.fillPopupBtnClick
    }
  }) : _vm._e(), _vm._v(" "), (this.compare_popup) ? _c('comparePopup', {
    attrs: {
      "userdata": _vm.form.user,
      "setUserID": _vm.setUserID,
      "fillUserData": _vm.fillUserData,
      "saveCardOwner": _vm.save,
      "hidepopup": _vm.hideComparePopup
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_vm._v("Kezdőőoldal")]), _vm._v(" "), _c('li', [_vm._v("Kártyabirtokosok")]), _vm._v(" "), _c('li', [_vm._v("Kártyabirtokos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-title"
  }, [_c('h1', [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")]), _vm._v("Kártyabirtokos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Kártyabirtokos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-sub-heading"
  }, [_c('h4', [_vm._v("Kártyák")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Kártyaszám")]), _vm._v(" "), _c('th', [_vm._v("Létrehozva")]), _vm._v(" "), _c('th', [_vm._v("Rf ID")]), _vm._v(" "), _c('th', [_vm._v("Jogok")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Státusz")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Megnevezés")]), _vm._v(" "), _c('th', [_vm._v("Érvényesség")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Engedélyezve")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Elsődleges")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e6b19640"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cardowner.vue
// module id = 60
// module chunks = 0